import anime from 'animejs'

let canvas;
let ctx;
const distance = 100;
const numberOfParticules = 24;
let animations;
let x, y;
const colors = [
	// '#FF324A',
	// '#31FFA6',
	// '#206EFF',
	// '#FFFF99',

	// '#067331',
	'#afd66b',
	'#afd66b',
	'#ffa735',
	'#dd0000',
	// '#ed145b'
];
const noop = function () {
};
const boom = function (ev) {
	const w = canvas.offsetWidth, h = canvas.offsetHeight;
	x = ev.clientX || ev.touches[0].clientX;
	y = ev.clientY || ev.touches[0].clientY;
	// x -= canvas.getBoundingClientRect().left;
	// y -= canvas.getBoundingClientRect().top;
	// x = canvas.width / 2;
	// y = canvas.height / 2;

	canvas.style.left = (x ) + 'px';
	canvas.style.top = (y - h * 0.5) + 'px';
	canvas.render();
	x = w * 0.5;
	y = h * 0.5;
	animateParticles(x, y);
	canvas.classList.add('active');
};
const getFontSize = function () {
	return 0.4 * parseFloat(getComputedStyle(document.documentElement).fontSize);
};
const setCanvasSize = function () {
	const size = 500;
	canvas.width = size;//window.innerWidth;
	canvas.height = size;//window.innerHeight;
};
const createParticule = function (x, y) {
	var p = {};
	p.x = x;
	p.y = y;
	p.color = colors[anime.random(0, colors.length - 1)];
	p.radius = anime.random(getFontSize(), getFontSize() * 2);
	p.draw = function () {
		ctx.beginPath();
		ctx.arc(p.x, p.y, p.radius, 0, 2 * Math.PI, true);
		ctx.fillStyle = p.color;
		ctx.fill();
	}
	return p;
};

const createParticles = function (x, y) {
	const particules = [];
	for (let i = 0; i < numberOfParticules; i++) {
		let p = createParticule(x, y);
		particules.push(p);
	}
	return particules;
};
const animateParticles = function (x, y) {
	setCanvasSize();
	const particules = createParticles(x, y);
	const particulesAnimation = anime({
		targets: particules,
		x: function (p) {
			return p.x + anime.random(-distance, distance);
		},
		y: function (p) {
			return p.y + anime.random(-distance, distance);
		},
		radius: 0,
		duration: function () {
			return anime.random(1200, 1800);
		},
		easing: 'easeOutExpo',
		complete: removeAnimation
	});
	animations.push(particulesAnimation);
};
const removeAnimation = function (animation) {
	const index = animations.indexOf(animation);
	if (index > -1) animations.splice(index, 1);
	if (animations.length == 0) {
		canvas.classList.remove('active');
	}
};

const init = function (canvasSelector) {
	document.addEventListener('DOMContentLoaded', function () {
		if (!canvasSelector) {
			canvas = document.createElement('canvas');
			document.body.appendChild(canvas);
		} else {
			canvas = document.querySelector(canvasSelector);
		}
		canvas.addEventListener('click', boom);
		setCanvasSize();
		canvas.classList.add('boom');
		ctx = canvas.getContext('2d');
		x = 0;
		y = 0;
		animations = [];

		var mainLoop = anime({
			duration: Infinity,
			update: function () {
				ctx.clearRect(0, 0, canvas.width, canvas.height);
				animations.forEach(function (anim) {
					anim.animatables.forEach(function (animatable) {
						animatable.target.draw();
					});
				});
			}
		});
	}, false);
};

export default {
	boom: window.enable_frontend_boom_effect ? boom : noop,
	init: window.enable_frontend_boom_effect ? init : noop,
};



// WEBPACK FOOTER //
// ./assets/js/nav-click.js